import { IconButton } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { withRouter } from "react-router-dom";
import Auth from "./Auth";
import "./assets/css/custom.css";
import BrowserWarningDialog from "./components/BrowserWarningDialog";
import ErrorPage from "./components/ErrorPage";
import ForceUpdateDialog from "./components/ForceUpdateDialog";
import { languages } from "./constants/languages";

class App extends React.Component {
  state = {
    showBrowserWarning: false,
    buildVersionNr1: 8, // forced update with modal
    currentVersionNr1: null,
    buildVersionNr2: 34, // update message in snackbar
    currentVersionNr2: null,
    showUpdateModal: false,
    showUpdateSnackbar: false,
    vertical: "bottom",
    horizontal: "center",
    isLoading: true,
    error: null,
  };

  handleClose = () => {
    this.setState({ showUpdateSnackbar: false });
  };

  loadGA = () => {
    try {
      const existingScript = document.getElementById("ga_script");
      if (!existingScript) {
        const script = document.createElement("script");
        script.src =
          "https://www.gstatic.com/firebasejs/7.6.1/firebase-analytics.js";
        script.id = "ga_script";
        document.body.appendChild(script);
        script.onload = () => {
          try {
            if (window.firebase && window.firebase.analytics) {
              window.firebase.analytics();
              // Send initial pageview
              this.sendPageView();
            }
          } catch (error) {
            console.error("Error initializing Firebase Analytics:", error);
          }
        };
        script.onerror = () => {
          console.error("Failed to load Firebase Analytics script");
        };
      }
    } catch (error) {
      console.error("Error in loadGA:", error);
    }
  };

  // Safe page tracking method with comprehensive error handling
  sendPageView = () => {
    try {
      // Firebase Analytics
      if (window.firebase && window.firebase.analytics) {
        window.firebase
          .analytics()
          .logEvent("page_view", {
            page_title: document.title || "Unknown Page",
            page_location: window.location.href || "",
            page_path: window.location.pathname || "/",
          })
          .catch((error) => {
            console.error("Firebase Analytics page_view event failed:", error);
          });
      }

      // Traditional Google Analytics (if enabled)
      if (window.gtag && typeof window.gtag === "function") {
        try {
          window.gtag("config", "UA-104350488-1", {
            page_path:
              (window.location.pathname || "/") +
              (window.location.search || ""),
            page_title: document.title || "Unknown Page",
          });
        } catch (error) {
          console.error("Google Analytics gtag config failed:", error);
        }
      }
    } catch (error) {
      console.error("Error in sendPageView:", error);
    }
  };

  UNSAFE_componentWillMount = () => {
    try {
      let consent = getCookieConsentValue();
      if (consent === "true") {
        this.loadGA();
      }

      if (
        navigator.userAgent.indexOf("MSIE") !== -1 ||
        navigator.appVersion.indexOf("Trident/") > 0
      ) {
        // Microsoft Internet Explorer detected.
        this.setState({ showBrowserWarning: true });
      }

      this.unsubscribe = window.firebase
        .firestore()
        .collection("version")
        .doc("version")
        .onSnapshot(
          (doc) => {
            try {
              let versionData = doc.data();

              if (!versionData) {
                this.setState({ isLoading: false });
                return;
              }

              let showUpdateModal = false;
              if (versionData.nr1 > this.state.buildVersionNr1) {
                showUpdateModal = true;
              }
              let showUpdateSnackbar = false;
              if (
                showUpdateModal === false &&
                versionData.nr2 > this.state.buildVersionNr2
              ) {
                showUpdateSnackbar = true;
              }

              this.setState({
                currentVersionNr1: versionData.nr1,
                currentVersionNr2: versionData.nr2,
                showUpdateModal: showUpdateModal,
                showUpdateSnackbar: showUpdateSnackbar,
                isLoading: false,
              });
            } catch (error) {
              this.setState({ error, isLoading: false });
            }
          },
          (error) => {
            this.setState({ error, isLoading: false });
          }
        );

      // Add history listener for page tracking with error handling
      try {
        this.unlisten = this.props.history.listen((location) => {
          try {
            // Send pageview when route changes
            this.sendPageView();
          } catch (error) {
            console.error("Error in history listener callback:", error);
          }
        });
      } catch (error) {
        console.error("Error setting up history listener:", error);
      }
    } catch (error) {
      console.error("Error in UNSAFE_componentWillMount:", error);
      this.setState({ error, isLoading: false });
    }
  };

  componentWillUnmount() {
    try {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      // Clean up history listener
      if (this.unlisten && typeof this.unlisten === "function") {
        this.unlisten();
      }
    } catch (error) {
      console.error("Error in componentWillUnmount:", error);
    }
  }

  render() {
    if (this.state.error) {
      return <ErrorPage error={this.state.error} />;
    }

    if (this.state.isLoading) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            fontFamily: "Roboto, sans-serif",
            backgroundColor: "#ffffff",
            color: "#3514FF",
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              border: "5px solid rgba(34, 120, 207, 0.2)",
              borderTop: "5px solid #3514FF",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              marginBottom: "20px",
            }}
          />
          <style>
            {`
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      );
    }

    return (
      <div>
        <CookieConsent
          onAccept={() => {
            this.loadGA();
          }}
          enableDeclineButton
          location="bottom"
          containerClasses="cookie-consent"
          buttonWrapperClasses="cookie-consent-buttons"
          buttonClasses="cookie-consent-button"
          declineButtonClasses="cookie-consent-button"
          contentClasses="cookie-consent-text"
          buttonText={languages.general.accept}
          declineButtonText={languages.general.decline}
          buttonStyle={{
            backgroundColor: "#3514FF",
            color: "#fff",
            fontWeight: 500,
            padding: "6px 16px",
            fontSize: "0.875rem",
            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
            lineHeight: 1.75,
            borderRadius: 4,
            letterSpacing: "0.02857em",
            textTransform: "uppercase",
          }}
          declineButtonStyle={{
            background: "none",
            color: "#fff",
            borderRadius: 4,
            fontSize: 11,
            margin: "15px 0px 15px 15px",
            border: "none",
            fontWeight: 500,
          }}
        >
          {languages.general.hey}{" "}
          <span role="img" aria-label="welcome" style={{ paddingRight: 10 }}>
            👋
          </span>
          {languages.general.cookies}{" "}
          <a
            href={languages.misc.privacyPolicyURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            {languages.general.privacyPolicy}
          </a>
          {languages.general.cookies2}.
        </CookieConsent>
        <Snackbar
          anchorOrigin={{
            vertical: this.state.vertical,
            horizontal: this.state.horizontal,
          }}
          open={this.state.showUpdateSnackbar}
          // onClose={this.handleClose}
          contentprops={{
            "aria-describedby": "message-id",
          }}
          message={
            <div>
              <span id="message-id">
                {languages.general.versionUpdateTitle}
              </span>
            </div>
          }
          action={
            <div style={{ color: "white" }}>
              <Button
                onClick={() => {
                  window.location.reload();
                }}
                color="inherit"
              >
                {languages.general.refreshPage}
              </Button>
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={this.handleClose}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>
          }
        />
        <BrowserWarningDialog open={this.state.showBrowserWarning} />
        <ForceUpdateDialog open={this.state.showUpdateModal} />

        <Auth />
      </div>
    );
  }
}

export default withRouter(App);
